import IAction from '@signageos/actions/dist/IAction';
import IOfflineAction from '@signageos/actions/dist/IOfflineAction';

export const SaveOfflineAction = 'Offline.SaveAction';
export interface SaveOfflineAction<TAction extends IAction<string>> extends IAction<typeof SaveOfflineAction> {
	action: TAction & IOfflineAction;
}

export const DeviceAlive = 'Offline.DeviceAlive';
export interface DeviceAlive {
	type: string;
}
